const previewindex = r => require.ensure([], () => r(require('@/page/preview/index.vue')), 'previewindex');
const previewkeepalive = r => require.ensure([], () => r(require('@/page/preview/previewkeepalive')), 'previewkeepalive');

const previewRouter = {
  path: '',
  component: previewkeepalive,
  meta: {
    icon: 'propertyAreaMge',
    right: [],
    isShowMenu: true,
    keepAlive:false
  },
  name: '示例预览',
  children: [{
    path: '/previewindex',
    component: previewindex,
    name: '示例预览',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive:false,
    },
  }
  ]
};

export default previewRouter;
